import { STORAGE_TAPROOT_ADDRESS, STORAGE_WALLET_TYPE } from '@/utils/constants'

/// Extension globals. A provider can appear after the first paint, and a
/// connected session has to subscribe before the first account or network event.
export const WALLET_PROVIDER_KEYS = [
	'unisat',
	'okxwallet',
	'phantom',
	'oyl',
	'dogeLabs',
	'tapprotocol',
	'HiroWalletProvider'
] as const

export function walletListenersReady(
	storage: { getItem(key: string): string | null },
	providers: Partial<Record<(typeof WALLET_PROVIDER_KEYS)[number], unknown>>
): boolean {
	if (storage.getItem(STORAGE_WALLET_TYPE)) return true
	if (storage.getItem(STORAGE_TAPROOT_ADDRESS)) return true
	return WALLET_PROVIDER_KEYS.some((key) => Boolean(providers[key]))
}
